module.exports = __webpack_public_path__ + "0fc195eba9f29c8dbb62786e9862d7ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/cd.jpg
// module id = lXFO
// module chunks = 13